import { Box, Button, ClickAwayListener, FormControl, FormControlLabel, FormHelperText, FormLabel, IconButton, Paper, Popper, Radio, RadioGroup, TextField, Tooltip, Typography, useTheme } from '@mui/material'
import React, { useRef, useState } from 'react'
import { useSimbaAIStore } from '../../../store/simbaai.store'
import { observer } from 'mobx-react'
import { Icons } from '../../../../shared/utils/icons.jsx'
import { toast } from 'react-toastify'
import api from '../../../service/api'

const issues = [
    { label: "Irrelevant Question", description: "The question is irrelevant to the topics of this practice session.", value: "irrelevant" },
    { label: "Correct option not found", description: "The correct answer for this question has not been found in the options provided.", value: "missingoption" },
    { label: "Incorrect answer", description: "The answer is marked as wrong even though the given answer is correct.", value: "incorrectanswer" },
    { label: "Other", description: "If the issue you are facing not one of the above please descripe your issue below.", value: "userdefined" },
]

const ReportIssue = observer( ( { questionIndex, attemptDetails, questionDetails } ) => {

    const [descriptionTouched, setDescriptionTouched] = useState( false )
    const [showReportOptions, setShowReportOptions] = useState( false )
    const [reportSuccessfull, setReportSuccessfull] = useState( false )
    const [reportDescription, setReportDescription] = useState( "" )
    const [reportDetails, setReportDetails] = useState( null )
    const [reporting, setReporting] = useState( false )

    const { palette, border } = useTheme()

    const SimbaAIStore = useSimbaAIStore()

    const reportIssuePopperContainer = useRef()
    const reportBtnRef = useRef()

    const disableSubmit = reportDetails?.issue_type === 'userdefined' ? !Boolean( reportDescription ) : !reportDetails?.issue_type

    const reportIssue = async () => {
        try {
            setReporting( true )
            const questionData = questionDetails || SimbaAIStore.getPracticeSessionQuestions[questionIndex ?? SimbaAIStore.getQuizState?.questionIndex]
            const practiceSessionId = attemptDetails?.practice_session?._id || SimbaAIStore.getQuizState?.attemptDetails?.practice_session?._id || SimbaAIStore.getQuizState?.attemptDetails?.practice_session_id

            const issueDetails = { ...issues.find( i => i.value === reportDetails?.issue_type ) }
            if ( issueDetails.value === "userdefined" ) {
                issueDetails.description = reportDescription
            }
            issueDetails.question_details = questionData
            issueDetails.practice_session_id = practiceSessionId
            issueDetails.question_index = questionIndex ?? SimbaAIStore.getQuizState?.questionIndex


            if ( practiceSessionId ) {
                await api.simbaAI.reportIssue( practiceSessionId, { issue_details: issueDetails } )

                setReportSuccessfull( true )
                setShowReportOptions( false )
            }
        } catch ( err ) {
            toast( err?.response )
        } finally {
            setReporting( false )
        }
    }

    return (
        <Box ref={reportIssuePopperContainer} sx={{
            flexShrink: 0
        }}>
            <Box component="span" ref={reportBtnRef} sx={{
                flexShrink: 0
            }}>
                <Button disabled={reportSuccessfull} onClick={() => setShowReportOptions( true )} sx={{ borderRadius: "10px", display: { xs: "none", sm: "flex" }, flexShrink: 0 }} startIcon={Icons.default.ReportOutlined} disableElevation color='greyed' >{reportSuccessfull ? "Issue reported" : "Report Issue"}</Button>
                <Tooltip title={reportSuccessfull ? "Issue reported" : "Report Issue"}>
                    <Box component="span">
                        <IconButton disabled={reportSuccessfull} onClick={() => setShowReportOptions( true )} sx={{ borderRadius: "10px", display: { xs: "flex", sm: "none" } }}  >{Icons.default.ReportOutlined}</IconButton>
                    </Box>
                </Tooltip>
            </Box>

            <Popper container={reportIssuePopperContainer.current} sx={{ zIndex: 3000 }} anchorEl={reportBtnRef.current} open={showReportOptions}>
                <ClickAwayListener onClickAway={() => setShowReportOptions( false )}>
                    <Paper sx={{ bgcolor: palette.contentBg, border: border[1], display: "flex", flexDirection: "column", gap: "10px" }} >

                        <Typography
                            variant="h1"
                            component="h2"
                            sx={{
                                borderBottom: border[1],
                                padding: "10px 20px",
                                fontWeight: "600",
                                fontSize: "16px"
                            }}>Report this question</Typography>


                        <Box
                            sx={{
                                padding: "20px",
                                display: "flex",
                                flexDirection: "column",
                                gap: "10px"
                            }}>
                            <Typography variant='subtitle2' color='textSecondary' component="p" >Select the issue you are facing:</Typography>
                            <FormControl>
                                <RadioGroup
                                    aria-labelledby="issue-radio-buttons-group"
                                    defaultValue="female"
                                    name="radio-buttons-group"
                                    sx={{ gap: "10px" }}
                                    value={reportDetails?.issue_type || ""}
                                    onChange={event => {
                                        setReportDetails( () => ( { issue_type: event.target.value } ) )
                                    }}
                                >
                                    {issues.map( issue => (
                                        <FormControlLabel sx={{ alignItems: "flex-start" }} key={issue.value} value={issue.value} control={<Radio size='small' />} label={
                                            <Box >
                                                <Typography color='textPrimary' component="p" variant='subtitle2'>{issue.label}</Typography>
                                                <Typography color='textSecondary' variant='caption' sx={{
                                                    marginTop: "-5px"
                                                }}>{issue.description}</Typography>
                                            </Box>
                                        } />
                                    ) )}
                                </RadioGroup>
                            </FormControl>
                            {reportDetails?.issue_type === "userdefined" && <Box sx={{
                                width: "100%"
                            }}>
                                <Typography variant='subtitle2' component="p" gutterBottom >Description *</Typography>
                                <TextField error={!reportDescription && descriptionTouched} onBlur={() => setDescriptionTouched( true )} fullWidth value={reportDescription} autoFocus onChange={( event ) => setReportDescription( event.target.value )} type="text" multiline rows={3} placeholder='Describe your issue here...' />
                                {!reportDescription && descriptionTouched && <FormHelperText sx={{ color: "error.main" }} >Required *</FormHelperText>}
                            </Box>}
                            <Box
                                sx={{
                                    display: "flex",
                                    marginTop: "20px",
                                    gap: "10px",
                                    alignItems: "center",
                                    justifyContent: "flex-end"
                                }}>
                                <Button onClick={() => setShowReportOptions( false )} disabled={reporting} sx={{ borderBottom: `4px solid ${palette.error.light + "99"}`, borderRadius: "10px" }} startIcon={Icons.default.CloseIcon} variant='outlined' color='error' >Cancel</Button>
                                <Button disabled={disableSubmit || reportSuccessfull || reporting} onClick={reportIssue} sx={{ borderBottom: `4px solid ${palette.primary.light + "99"}`, borderRadius: "10px" }} variant='contained' endIcon={Icons.default.CheckIcon} disableElevation  >Submit Report</Button>
                            </Box>
                        </Box>
                    </Paper>
                </ClickAwayListener>
            </Popper>
        </Box>
    );
} )

export default ReportIssue
